import { Badge, Box, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import StatusComponent from "../../../../../../../../../../components/status"
import { PropsLeft } from "./types"
import { DinamicForm } from "../../../../../../../../../../components/dinamicForm"
import { DateModalSimple } from "../../../../../../../../../../components/dinamicForm/dateModal"
import dayjs from "dayjs"
import { useEffect, useRef, useState } from "react"
import { DetailAndUploadOfEvidences } from "../../../../../../../../../../components/detailAndUploadOfEvidences"
import { CustomeIconButton } from "../../../../../../../../../../components/customeIconButton"
import { ViewEvidence } from "../../../../../../../../../../components/detailAndUploadOfEvidences/enum"
import { formatEvidenceToUploadEvidence } from "../../../../../../../../../../components/uploadEvidence/methods"
import { Status } from "../../../../../../../../../../utils/enums"
import { icons } from "../../../../../../../../../../utils/icons"
import { toUnitTimeZone } from "../../../../../../../../../../utils/methods/calcDate"
import { DestinationType } from "../../../create/enums/destinationType"


export const Left = (props: PropsLeft) => {
    const { t } = useTranslation()
    const styles = useStyles()

    const [view, setView] = useState<ViewEvidence>(ViewEvidence.DETAIL)
    const { defaultEvidence, evidencesDrawer, evidencesRequiredAreLoad, setDeletedsEvidencesList, setEvidencesDrawer, setEvidencesRequiredAreLoad, } = props.evidenceUpload

    const drawerRef = useRef<{ closeDrawer?: () => void }>({});


    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const validateCanUpload = () => {
        if (props.status == Status.STARTED) {
            setView(ViewEvidence.EDIT)
            const response = formatEvidenceToUploadEvidence({ evidenceConfig: props.evidenceConfig?.evidence, evidencesDetail: props.evidences })
            setEvidencesRequiredAreLoad({ ...props.evidenceConfig?.requireList })
            defaultEvidence({ evidencesConfig: response })
        }
    }

    useEffect(() => {
        let errorMessage = ''
        /* const destinationTimeZoneCode = props.destinationFinal?.timeZone?.code; */

        if (props.destinationFinal?.timeZone) {
            const normalizedFrom = dayjs(props.defaultValues.from).tz(localTimeZone, true);
            const normalizedTo = dayjs(props.defaultValues.to).tz(localTimeZone, true);
            if (normalizedTo.isBefore(normalizedFrom.add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        } else {
            if (dayjs(props.defaultValues.to).isBefore(dayjs(props.defaultValues.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        }

        /* if (dayjs(props.defaultValues.to).isBefore(dayjs(props.defaultValues.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') } */

        props.setErrors(prev => ({
            ...prev,
            to: errorMessage
        }))
    }, [props.defaultValues])

    /* useEffect(() => {
        const destinationTimeZoneCode = toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value);

        if (props.edit) {

            if (!(props.oldTypeDestination == DestinationType.DESTINATION && props.destinationFinal?.type == DestinationType.DESTINATION)) {

                if (props.destinationFinal?.timeZone) {
                    const isMinor = dayjs(props.defaultValues.from).isBefore(dayjs(destinationTimeZoneCode))
                    if (isMinor) {
                        props.setDefaultValues({ from: dayjs(destinationTimeZoneCode), to: null })
                        props.handleChangeCrud({ name: 'from', date: dayjs(destinationTimeZoneCode) })
                    }
                } else {
                    const isMinor = dayjs(props.defaultValues.from).isBefore(dayjs())
                    if (isMinor) {
                        props.setDefaultValues({ from: dayjs(), to: null })
                        props.handleChangeCrud({ name: 'from', date: dayjs() })
                    }
                }

            }
        }

    }, [props.destinationFinal]); */

    useEffect(() => {

        if (!props.dataActivity?.typeOfActivity && props.dataActivity?.open) {
            const { open, ...rest } = props.dataActivity;
            props.handleDataActivity(rest);
        }

        if (props.dataActivity?.typeOfActivity?.openField) {
            props.setInputLastActivity((prevInput) => ({
                open: props.openField,
                ...prevInput,
            }));
        } else {
            props.setInputLastActivity((prevInput) => {
                const { open, ...rest } = prevInput;
                return rest;
            });
        }
    }, [props.dataActivity?.typeOfActivity]);

    /*     useEffect(() => {
            const destinationTimeZoneCode = toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value);
    
            if (props.edit) {
                if (props.destinationFinal?.timeZone) {
                    props.setDefaultValues({ from: dayjs(destinationTimeZoneCode), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs(destinationTimeZoneCode) })
                } else if (!props.destinationFinal?.timeZone) {
                    props.setDefaultValues({ from: dayjs(), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs() })
                }
            }
    
        }, [props.destinationFinal]); */

    return (
        <Box sx={styles.body}>
            <Box sx={styles.header}>
                <Typography sx={styles.title} variant="title_grey_dark">{t('loogbook.titles.editActivity')}</Typography>
                <StatusComponent type="chip" size="small" color={props.statusLocale.color} msg={props.statusLocale.text} />
            </Box>

            <Box>
                <Box sx={styles.containerTitle(props.isFree)}>
                    <DinamicForm input={Object.values(props.inputActivity)} values={props.dataActivity} onChange={props.onChangeCrud} />
                </Box>

                {!props.isFree &&
                    <Box sx={styles.containerDate}>
                        <DateModalSimple
                            timeZone={props?.destinationFinal?.timeZone?.code ?? localTimeZone}
                            setIsToBiggerThanFrom={props.setIsToBiggerThanFrom}
                            buttonTitle="Desde *"
                            defaultDate={props.defaultValues.from}
                            getDate={(date) => { props.getDate(date, 'from') }}
                            payload={{ max: props.defaultValues.to, min: props.destinationFinal?.timeZone ? dayjs(toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value)) : dayjs(), is: { start: true, startLower: props.isToBiggerThanFrom } }}
                            title='SELECCIÓN DE FECHA DE INICIO'
                            name="from"
                            errorMsg={props.errors?.from}
                            error={!!(props.errors.from)}
                            disable
                        />

                        <DateModalSimple
                            timeZone={props?.destinationFinal?.timeZone?.code ?? localTimeZone}
                            setIsToBiggerThanFrom={props.setIsToBiggerThanFrom}
                            buttonTitle="Hasta *"
                            defaultDate={props.defaultValues.to} getDate={(date) => { props.getDate(date, 'to') }}
                            /* payload={{ min: props.defaultValues.from ?? dayjs(), is: { end: true, endBigger: props.isToBiggerThanFrom } }}  */
                            payload={{ min: props.defaultValues.from ?? dayjs(), is: { end: true, endBigger: props.isToBiggerThanFrom } }}
                            title='SELECCIÓN DE FECHA DE FIN'
                            name="to"
                            errorMsg={props.errors?.to}
                            error={!!(props.errors.to)}
                            disable
                        />
                    </Box>
                }

                <Grid container spacing={1} className="mb">
                    <Grid item xs={11}>
                        <DinamicForm input={Object.values(props.inputSecondActivity)} values={props.dataActivity} onChange={props.onChangeCrud} />
                    </Grid>

                    <Grid item xs={1}>
                        <Box sx={styles.containerClip}>
                            <DetailAndUploadOfEvidences
                                Node={({ payload: { openDrawer, closeDrawer } }) => {
                                    /* setDrawerHandlers({ closeDrawer }); */
                                    drawerRef.current.closeDrawer = closeDrawer;
                                    return (
                                        <Badge sx={styles.badge} badgeContent={props.badgeContent}>
                                            <CustomeIconButton
                                                title={view == ViewEvidence.DETAIL ? t('general.seeEvidence') : t('loogbook.titles.chargeEvidence')}
                                                icon={icons('clip')}
                                                iconButtonProps={{
                                                    disabled: props.disabledButton,
                                                    /* color: 'primary', */
                                                    sx: styles.clip(props.disabledButton),
                                                    onClick: () => {
                                                        setDeletedsEvidencesList([])
                                                        openDrawer()
                                                        validateCanUpload()
                                                    }
                                                }} />
                                        </Badge>
                                    )
                                }}
                                view={view}
                                save={() => {
                                    props.getEvidence({ evidences: evidencesDrawer });
                                    /* if (drawerHandlers.closeDrawer) {
                                        drawerHandlers.closeDrawer();
                                    } */
                                    if (drawerRef.current.closeDrawer) {
                                        drawerRef.current.closeDrawer();
                                    }
                                }}
                                detail={{
                                    evidences: {
                                        image: props.evidences?.images,
                                        comment: props.evidences?.comments,
                                        documents: props.evidences?.documents,
                                        video: props.evidences?.video,
                                    },
                                    existEvidences: props.existEvidences
                                }}
                                upload={{
                                    evidencesDrawer,
                                    evidencesRequiredAreLoad: evidencesRequiredAreLoad,
                                    deletedEvidence: ({ name }) => { setDeletedsEvidencesList(prev => [...prev, name]) },
                                    fakeDelete: true,
                                    close: () => { },
                                    setEvidencesDrawer,
                                    setEvidencesRequiredAreLoad,
                                    uploadName: `logbook/${props.activityId}`,
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>

                <DinamicForm input={Object.values(props.inputLastActivity)} values={props.dataActivity} onChange={props.onChangeCrud} />
            </Box>
        </Box>
    )
}